module.exports = {
    // Enable or disable server-side rendering
    enableSSR: true,

    // Enable or disable dynamic imports (code splitting)
    enableDynamicImports: true,

    // Enable or disable speed measure plugin to measure your webpack build speed
    enableSpeedMeasure: false,

    // The env vars to expose on the client side. If you add them here, they will
    // be available on the client as process.env[VAR_NAME], same as they would be
    // in node.js.
    //
    // **WARNING**: Be careful not to expose any secrets here!
    clientEnv: [
        "NODE_ENV",
        "APPLICATION_BASE_URL",
        "LOCAL_ASSET_PATH",
        "INTERNAL_NODE_API_URL",
        "EXTERNAL_CLOUDFLARE_API_URL",
        "EXTERNAL_DIRECT_API_URL",
        "DOCTORS_EXTERNAL_DIRECT_API_URL",
        "EXTERNAL_LABS_DIRECT_API_URL",
        "EXTERNAL_PPMC_DIRECT_API_URL",
        "BUILD_ENV",
        "EXTERNAL_BASE_URL",
        "GTM_ID",
        "DOCTORS_API_URL",
        "TOKEN",
        "AWS_ACCESS_KEY_ID",
        "AWS_SECRET_ACCESS_KEY",
        "CDN_ASSET_PATH",
        "S3_FOLDER",
        "S3_BUCKET",
        "TC_APP_NAME",
        "TC_LANGUAGE_LOCALE",
        "TC_PARTNER_KEY",
        "TC_TITLE_STRING",
        "RECAPTCHA_KEY",
        "SERVER_PATH",
        "BUILD_NUMBER",
        "RUDDER_KEY",
        "RUDDER_AMP_KEY",
        "RUDDER_URI",
        "RUDDER_URL",
        "GPT_ID",
        "PUBLIC_ASSET_PATH",
        "TATA_CLIENT_ID",
        "TATA_SSO_SCRIPT",
        "LOCAL_BUILD_PUBLIC_ASSET_PATH",
        "OUTPUT_PATH",
        "APPLICATION",
        "PUBLIC_OUTPUT_PATH",
        "GOOGLE_API_KEY_CLIENT",
        "ENV_NAME",
        "HIDE_OTP_ON_CALL",
        "FACEBOOK_PIXEL_ID",
        "SENTRY",
    ],
    // Apart from the client env vars, the following keys will be ignored by trufflehog.
    // Add any keys that are not required to be scanned for secrets and are safe to be present in the client bundle.
    trufflehog_ignore_keys: [
        "APPLICATION_PORT",
        "DEV_SERVER_PORT",
        "REDIS_PORT",
        "APM.TRANSACTION_SAMPLE_RATE",
        "DEV_SERVER_HOSTNAME",
        "GOOGLE_API_KEY_CLIENT",
        "GOOGLE_API_KEY_SERVER",
        "DEV_SERVER_HOST_URL",
    ],

    /* The identifier to use for css-modules.
     */
    cssModulesIdentifierProd: "[name]__[local]__[hash:base64:5]",
    cssModulesIdentifierDev: "[name]__[local]",
    // Isomorphic configuration
    isomorphicConfig: {
        debug: true,

        assets: {
            images: {
                extensions: ["png", "jpg", "jpeg", "gif", "ico", "svg", "json"],
            },
        },
    },
    defaultCity: "New Delhi",
}
